import React from 'react'
import {
  Typography,
  Grid,
  Chip,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { WorkOrderDispatchDto } from '../entities/DispatchOt'

interface OtDescriptionProps {
  otDescription: WorkOrderDispatchDto
}

const useStyles = makeStyles((theme) => ({
  item: {
    textAlign: 'center', // Centrar texto en todas las vistas
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none',
        paddingBottom: 0
      }
    }
  },
  title: {
    display: 'block',
    marginBottom: theme.spacing(0.5)
  }
}))

export const OtDescription: React.FC<OtDescriptionProps> = ({
  otDescription
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Box p={2}>
      <Grid
        container
        spacing={isMobile ? 0 : 3}
        alignItems='center'
        justifyContent='center'
      >
        <Grid item xs={12} sm={6} md={3} className={classes.item}>
          <Typography
            variant='caption'
            color='textSecondary'
            className={classes.title}
          >
            Work Order Tag
          </Typography>
          <Typography variant='h6' component='div'>
            {otDescription.workOrderTag || 'Sin Tag'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3} className={classes.item}>
          <Typography
            variant='caption'
            color='textSecondary'
            className={classes.title}
          >
            Tipo
          </Typography>
          <Chip
            label={otDescription.rtv ? 'RTV' : 'Normal'}
            color={otDescription.rtv ? 'secondary' : 'primary'}
            size='small'
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className={classes.item}>
          <Typography
            variant='caption'
            color='textSecondary'
            className={classes.title}
          >
            Rutas de Picking
          </Typography>
          <Typography variant='body1' component='div'>
            {otDescription.pickingRoutesIds}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3} className={classes.item}>
          <Typography
            variant='caption'
            color='textSecondary'
            className={classes.title}
          >
            Total Items
          </Typography>
          <Typography variant='h6' component='div'>
            {otDescription.totalItems}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
